import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'messageFilter',
  standalone:true
})
export class MessageFilterPipe implements PipeTransform {

  
  transform(messageArray: any[], condition: string): any[] {
    if (!Array.isArray(messageArray)) {
      return [];
    }

    switch (condition) {
      case 'files':
        return messageArray.filter(item => item?.messageType === 'FILE');
      case 'links':
        return messageArray.filter(item => typeof item?.message === 'string' && item?.messageType === 'TEXT' && (item.message.startsWith('https://') || item.message.startsWith('http://')));
      case 'all':
        return messageArray.filter(item => item?.messageType === 'FILE' || (typeof item?.message === 'string' && (item.message.startsWith('https://') || item.message.startsWith('http://'))));
      default:
        return messageArray;
    }
  }

}
